import { Component, OnInit,Inject,DoCheck, ChangeDetectorRef } from '@angular/core';
import { Router } from "@angular/router";
import { Globals } from "src/app/globals";
import { DOCUMENT } from '@angular/common';
import { Location } from '@angular/common';
import Swal from "sweetalert2";

import * as moment from 'moment';
import 'moment/locale/pt-br';

import { Subscription } from 'rxjs';

import { EventoscomService } from '../servicios/eventoscom.service';





@Component({
  selector: 'app-newhome',
  templateUrl: './newhome.component.html',
  styleUrls: ['./newhome.component.css']
})
export class NewhomeComponent implements OnInit {


    message: any;
   // subscription: Subscription;
    perfil3;
    perfil2;

    data

  constructor(private router: Router,public global: Globals,@Inject(DOCUMENT) private document: Document,public _location: Location,private eventoscomService: EventoscomService, private dc: ChangeDetectorRef) {

  //  this.subscription = this.eventoscomService.getMessage().subscribe(message  => { this.mievento(); this.message = message; });

  }



  mievento(){

  //////conole.log("Funcionaaaaaa888888");

  }



  ngOnInit() {

    this.data = JSON.parse(localStorage.getItem('correo'))


    ////conole.log("Entra a esto");
    this.Idioma();

    const date = moment();
    let dateInFormat = date.format('YYYY.M.D');
    //////conole.log(dateInFormat);

    if (this.data.SuperAdministrador == "1") {

      this.Superadministrador = true;
    }

    if(this.data.SuperAdministrador=="0"){
      this.perfil2=true;
    }

    if(this.data.SuperAdministrador=="2"){
      this.perfil3=true;
    }

  }

  Superadministrador = false;

  Boton1Texto;
  Boton2Texto;
  Boton3Texto;
  Boton4Texto;
  Boton5Texto;
  Boton6Texto;
  Boton7Texto;
  Boton8Texto;
  Boton9Texto;
  Boton10Texto;
  Boton11Texto;
  Boton12Texto;
  Boton13Texto;
  BotonIrAmodulo;


  Idioma(){


    if (
      this.global.lenguaje == "es" ||
      this.global.lenguaje == "ESPANOL" ||
      this.global.lenguaje == "ESPAÑOL" ||
      this.global.lenguaje.toLowerCase() == "español"
    ) {

      this.Boton1Texto = "1.  Encuesta Compliance 2019 ";
      this.Boton2Texto = "2.Encuesta Compliance Año Actual";
      this.Boton3Texto = "3. Admin Conflictos Jefe";
      this.Boton4Texto = "4. Admin Conflictos Compliance";
      this.Boton5Texto = "5. Compliance Hoja De Vida";
      this.Boton6Texto = "6. Administrador De Usuarios";
      this.Boton7Texto = "7. Actualizador De Conflictos";
      this.Boton8Texto = "8. Editor Texto Preguntas";
      this.Boton9Texto = "9. Módulo Notificaciones";
      this.Boton10Texto = "10. Módulo Envío Masivo Encuesta";
      this.Boton11Texto = "11. Módulo Estadístico y de Reportes";
      this.Boton12Texto = "12. Módulo Nuevo 2";
      this.Boton13Texto = "13. Preubas Charts";
      this.BotonIrAmodulo = "Ver Módulo";


    } else {

      this.Boton1Texto = "1. Compliance Survey 2019";
      this.Boton2Texto = "2. Compliance Survey Present Year";
      this.Boton3Texto = "3. Admin Conflicts Boss";
      this.Boton4Texto = "4. Admin Conflicts Compliance";
      this.Boton5Texto = "5. Compliance Resume";
      this.Boton6Texto = "6. User Administrator";
      this.Boton7Texto = "7. Conflict Updater";
      this.Boton8Texto = "8. Text Editor Questions";
      this.Boton9Texto = "9. Notifications module";
      this.Boton10Texto = "10. Module Mass Shipping Survey";
      this.Boton11Texto = "11. Reports Module";
      this.Boton12Texto = "12. New Module 2";
      this.Boton13Texto = "13. New Module Charts";
      this.BotonIrAmodulo = "Go to module";

    }

    this.dc.detectChanges();

  }


  Es(){
    this.global.lenguaje = "es";
    this.ngOnInit();
  }

  En(){
    this.global.lenguaje = "en";
    this.ngOnInit();
  }


  Boton1(){
    window.open("https://compliance.fronteraenergy.ca/administradorpreguntas");

  }
  Boton2(){
    window.open("/administradorpreguntas");
  }
  Boton3(){
    window.open("https://encuestaadmonjefe.fronteraenergy.ca");



  }
  Boton4(){

    //window.open("https://compliance-admin-dot-frontera-habilitantes-dev.appspot.com/#/home");

    window.open("https://admonareacompliance.fronteraenergy.ca");


  }
  Boton5(){
    window.open("https://hojadevidaencuestaconflictos.fronteraenergy.ca");

  }
  Boton6(){
    window.open("/administrar-usuario");

  }
  Boton7(){
    window.open("/administradorconflictos");
  }
  Boton8(){
    window.open("/EditorDePreguntasComplianceFase4");
    //this.router.navigate([""]);
  }
  Boton9(){
    window.open("https://docs.google.com/spreadsheets/d/1egdnRr9_SFW13gVhmgoURWJ1M5fzJYLM1ZfdjdGLSUE/edit#gid=786883924");

  }

  Boton10(){
    window.open("https://docs.google.com/spreadsheets/d/111ZY77u0wCUm4r2GeImbDVKoe6dT84JZEZM7XUSogoM/edit#gid=0");
  }

  Boton13(){
    window.open("/administrar-usuario");
  }

  Boton11(){
    window.open("/reporte-estadistico");
  }

  Boton12(){
    window.open("/reporte-estadistico");
  }

  testokokk = false;

  funciontest(){
    this.testokokk = true;
  }

  funciontest3(){
    this.testokokk = false;
  }

  funciontest2(){
    //////conole.log("se ejecuta okokokaaaaaaaaa");
    return false;
  }


}
